import { Link } from "react-router-dom"; // Import Link for page navigation

export default function Menu() {
    return (
        <>
            <ul className="navigation" >
                <li>
                    <a href="https://newranss.com.au/#banner"  style={{fontSize: '22px'}}>Home</a> {/* Scroll to Home section */}
                </li>
                <li>
                    <a href="https://services.newranss.com.au/" style={{fontSize: '22px'}}>Services</a> {/* Navigate to Services Page */}
                </li>
                <li>
                    <a href="https://newranss.com.au/#about" style={{fontSize: '22px'}}>About</a> {/* Scroll to About section */}
                </li>
                <li>
                    <a href="https://newranss.com.au/#contact" style={{fontSize: '22px'}}>Contact</a> {/* Scroll to Contact section */}
                </li>
                <li>
                    <a href="https://Referrals.newranss.com.au" style={{fontSize: '22px'}}>Referrals</a> {/* Scroll to Contact section */}
                </li>
            </ul>
        </>
    );
}
